import { Link } from 'react-router-dom'//npm install react-router-dom

function EventiItemAuth({ accettazione, dataInizio, dataFine, tipologia, titolo, img, comune, provincia, id }) {
    const imgArray = img.split(',')

    let data; let opaco = 1; let res = true
    accettazione === 'null' && (opaco = 0.6)//opacity se l'evento è annullato
    if (accettazione === 'false' || accettazione === 'rejection')
        res = false //per togliere il button 'elimina'

    if (dataInizio !== dataFine) {
        data = <p>Dal <b>{dataInizio.split("-").reverse().join("-")}</b> al <b>{dataFine.split("-").reverse().join("-")}</b></p>
    } else data = <p><b>{dataInizio.split("-").reverse().join("-")}</b></p>

    return (<>
        <div className="col">
            <div className="card" style={{ opacity: opaco }}>
                <Link to={{ pathname: `/eventiDetails/${id}` }} style={{ textDecoration: 'none' }}>
                    {img ? (
                        <img src={`https://leuro-bucket.s3.amazonaws.com/${imgArray[0]}`} className="card-img-top" />) :
                        (
                            <img src={`https://leuro-bucket.s3.amazonaws.com/evento_senza_foto.jpg`} className="card-img-top" />)
                    }
                    <div className="card-body">
                        <h3 className="card-title"><b>{titolo}</b></h3>
                        {data}
                        <p>{comune.charAt(0).toUpperCase() + comune.slice(1)} ({provincia.toUpperCase()})
                        </p>
                        <p style={{
                            color: 'white',
                            backgroundColor: 'maroon',
                            width: 'max-content',
                            padding: '5px',
                        }}>{tipologia}
                        </p>
                    </div>
                </Link>
            </div>
        </div>
    </>)
}
export default EventiItemAuth
